import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import Layout from '../layouts/Layout';
import Header from '../modules/Header';
import Footer from '../modules/Footer';
import EmptySpace from '../modules/EmptySpace';
import EmailSignature from './EmailSignature';
import { url } from '../../../config';
import { PRIMARY_COLOR, GRAY_BG_COLOR } from '../../../constants';

//Style
import { body, fontWeightBold, marginBottom } from '../../../helpers/getEmailStyles';

class BookingRequestGuest extends React.Component {

  static propTypes = {
    content: PropTypes.shape({
      guestName: PropTypes.string.isRequired,
      checkIn: PropTypes.string.isRequired,
      listTitle: PropTypes.string.isRequired,
      threadId: PropTypes.number.isRequired,
    }).isRequired

  };

  render() {
    const { content: { guestName, listTitle, checkIn, threadId, logo, siteName, checkOut } } = this.props;
    let checkInDate, messageURL, checkOutDate
    checkInDate = checkIn != null ? moment(checkIn).format('ddd, Do MMM, YYYY') : '',
      messageURL = url + '/message/' + threadId + '/guest';
    checkOutDate = checkOut != null ? moment(checkOut).format('ddd, Do MMM, YYYY') : ''

    return (
      <Layout>
        <Header color={PRIMARY_COLOR} backgroundColor={GRAY_BG_COLOR} logo={logo} siteName={siteName} />
        <div style={body}>
          <div style={fontWeightBold}>
            Bonjour {guestName},
          </div>
          <EmptySpace height={20} />
          <div>
            Votre demande de réservation a été envoyée à l'hôte ! Il vous répondra dans les 24 heures.
          </div>
          <EmptySpace height={20} />
          <div style={marginBottom}><span style={fontWeightBold}>Détails de l'annonce :</span></div>
          <div style={marginBottom}><span style={fontWeightBold}>Nom de l'annonce :</span> {listTitle}</div>
          <div style={marginBottom}><span style={fontWeightBold}>Arrivée :</span> {checkInDate}</div>
          <div><span style={fontWeightBold}>Départ :</span> {checkOutDate}</div>
          <EmptySpace height={20} />
          <div>Nous vous tiendrons informé. Restez connecté !</div>
          <EmptySpace height={20} />
          <EmailSignature siteName={siteName} />
        </div>
        <EmptySpace height={40} />
        <Footer siteName={siteName} />
        <EmptySpace height={20} />
      </Layout>
    );
  }

}

export default BookingRequestGuest;